<div
  style="margin-left: -1.5rem !important; margin-right: -1.5rem !important"
  class="px-4 py-1 bg-white"
>
  <ion-list lines="none">
    <ion-item>
      <ion-label>{{ title }} </ion-label>

      <div slot="end" class="color-medium">
        {{ value }}
      </div>
    </ion-item>
  </ion-list>
</div>
